@if (!link) {
<button
  [ngClass]="[size, type | lowercase, 't-' + size]"
  [disabled]="disabled"
  (click)="btnClick.emit()"
>
  <ng-content *ngTemplateOutlet="body"></ng-content>
</button>
} @else { @if (link && !isExternal) {
<a
  class="button"
  [ngClass]="[size, type | lowercase, 't-' + size, disabled ? 'disabled' : '']"
  (click)="btnClick.emit()"
  [routerLink]="link"
  [queryParams]="queryParams"
>
  <ng-content *ngTemplateOutlet="body"></ng-content>
</a>
} @if (link && isExternal) {
<a
  class="button"
  [ngClass]="[size, type | lowercase, 't-' + size, disabled ? 'disabled' : '']"
  (click)="btnClick.emit()"
  [href]="link"
>
  <ng-content *ngTemplateOutlet="body"></ng-content>
</a>
} }

<ng-template #body>
  <ng-content></ng-content>
</ng-template>
